export const formatSubunits = (subunits) => {
    return subunits?.map((subunit) => ({
      label: subunit?.description,
      courseCode: subunit?.code,
      sectionNumber: subunit?.sectionNumber,
      value: subunit?._id,
    }));
  };
  
  export const getSubunitIDList = (subunits) => {
    return subunits?.map((subunit) =>  subunit?._id);
  };
  
  export const getSubunitTitleList = (subunits) => {
    return subunits?.map((subunit) =>  subunit?.description);
  };
  
  export const convertSubunitListToMap = (subunits) => {
    const subunitMap = {}
    subunits.forEach(subunit => {
      subunitMap[subunit?._id] = {
        label: subunit?.description,
        courseCode: subunit?.code,
        sectionNumber: subunit?.sectionNumber,
        value: subunit?._id,
      }
    })
  }